import ClasImpl from '@/serviceImpl/ClasImpl';
import {Manifest} from '@/domain/services/Clas';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const getManifestUseCase = async (): Promise<Manifest | undefined> => {
  const accessToken = getCredentialsOrThrow();

  try {
    return await ClasImpl.manifest(accessToken);
  } catch (error) {
    console.error('Error fetching projects', error);
    throw error;
  }

};

export default getManifestUseCase;